import * as React from 'react';
import styled from 'styled-components';

import { COLORS } from '../styles';

const FooterContainer = styled.footer`
  margin-top: auto;
`;

const FooterGlobalContent = styled.section`
  min-height: 8px;
  background-color: ${COLORS.primary_700};
  color: white;
`;

const Footer = ({ children }: any) => {
  return (
    <FooterContainer>
      {children}
      <FooterGlobalContent />
    </FooterContainer>
  );
};

export default Footer;
